type FormValueTypes = string | number | boolean | string[];
type FormValues = Record<string, FormValueTypes | undefined>;

export const checkVisibilityCondition = (
	condition: {
		field: string;
		operator: 'equals' | 'notEquals' | 'contains' | 'in' | 'greaterThan' | 'lessThan';
		value: string | number | boolean;
	},
	formValues: FormValues = {},
	value?: string,
	defaultVisibility = true,
) => {
	const fieldValue = value ?? formValues[condition.field];

	if (fieldValue === undefined) return defaultVisibility;

	switch (condition.operator) {
		case 'equals':
			return fieldValue === condition.value;
		case 'notEquals':
			return fieldValue !== condition.value;
		case 'contains':
			return Array.isArray(fieldValue) && fieldValue.includes(condition.value.toString());
		case 'in':
			return Array.isArray(condition.value) && condition.value.includes(fieldValue);
		default:
			return true;
	}
};
